// extracted by mini-css-extract-plugin
export default {"container":"udccO","consentItem":"BR_i3","text":"j3hd_","title":"B5rT3","subtitle":"L372z","value":"sYlsL"};